import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Invoice: {
    keyFields: ['number'],
  },
};
